import React, { useContext } from 'react';
import TextInput from '../UI/TextInput';
import MultiSelect from '../UI/MultiSelect';
import SingleDatePicker from '../UI/SingleDatePicker';
import TextArea from '../UI/TextArea';
import { TabContext } from '../../context/TabContext';

const PostOption = props => {
  const { 
    register, 
    onChangeHandler, 
    handleMultiChange, 
    inputValue, 
    list, 
    selectValue, 
    handleTimeCallback, 
    setInputValue, 
    onChangeSingleValue
  } = useContext(TabContext);

  return (
    <div className="advanced-option">
      <h6>
        {props.label}{props.isRequired && <span style={{color: "red"}}> *</span>}
      </h6>
      {props.type === "text" && (
        <TextInput 
          name={props.name} 
          type={props.type} 
          register={register()}
          value={inputValue[props.name]}
          onChange={onChangeSingleValue}
          placeholder="Type something..."
          setInputValue={setInputValue}
          inputValue={inputValue}
        />
      )}
      {props.type === "textarea" && (
        <TextArea 
          name={props.name} 
          register={register()}
          value={inputValue[props.name]}
          onChange={onChangeSingleValue}
          placeholder="Up To 600 characters"
        />
      )}
      {props.type === "date" && (
        <SingleDatePicker
          handleTimeCallback={handleTimeCallback}
          name={props.name}
          id={props.name}
          wrapStyle="advanced-picker-wrap"
          cancelCallback = {() => {setInputValue({
            ...inputValue,
            [props.name]: {}
          })}}
          isPicked = {()=>Object.keys(inputValue[props.name]).length === 0}
        />
      )}
      {props.type === "select" && (
        <MultiSelect 
          onChangeHandler={onChangeHandler}
          handleMultiChange={handleMultiChange}
          name={props.name}
          list={list}
          selectValue={selectValue.filter(item => item.type === props.name)}
          styles="react-select-container advanced"
          prefixStyles="react-select"
          indicator={false}
          info_type={props.info_type}
        />
      )}
    </div>
  )
}

export default PostOption;